import classNames from 'classnames';
import React from 'react';

import Link, { LinkProps } from '../components/ui/Link';

export const getHyperlink = (props: LinkProps) => (
  (chunks: React.ReactNode) => (
    <Link {...props} className={classNames('text-black underline cursor-pointer select-none', props.className)}>
      {chunks}
    </Link>
  )
);
